import React from "react";
import { useOnboarding } from "@/hooks/use-onboarding";
import { OnboardingView } from "@/views/onboarding/onboarding-view";
import { Button } from "@/components/ui/buttons/button";

export const Onboarding: React.FC = () => {
  const {
    step,
    nextStep,
    previousStep,
    retry,
    data,
    updateData,
    isLoading,
    error,
    pickStarter,
    createPlayer,
    verifyUsername,
    updateCountry,
    completeOnboarding,
  } = useOnboarding();

  if (isLoading) {
    return (
      <main
        className="w-full h-full  bg-pk-night-2 flex flex-col items-center justify-center p-6 text-white"
        style={{
          height: "min(100svh, calc(480px * 18 / 9))",
          maxWidth: "480px",
        }}
      >
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-pk-blue-3 border-t-transparent rounded-full animate-spin" />
          <p className="text-white font-black italic animate-pulse uppercase tracking-widest">
            Checking Status...
          </p>
        </div>
      </main>
    );
  }

  if (step !== "welcome") {
    return (
      <OnboardingView
        step={step}
        nextStep={nextStep}
        previousStep={previousStep}
        retry={retry}
        data={data}
        updateData={updateData}
        isLoading={isLoading}
        error={error}
        pickStarter={pickStarter}
        createPlayer={createPlayer}
        verifyUsername={verifyUsername}
        updateCountry={updateCountry}
        completeOnboarding={completeOnboarding}
      />
    );
  }

  return (
    <main
      className="w-full h-full  bg-pk-night-2 flex flex-col items-center justify-center p-6 text-white"
      style={{
        height: "min(100svh, calc(480px * 18 / 9))",
        maxWidth: "480px",
      }}
    >
      <div className="flex flex-col items-center gap-12 max-w-sm w-full">
        <div className="flex flex-col gap-1 items-center justify-center">
          <span className="opacity-50 text-lg font-black uppercase">
            Welcome to
          </span>
          <h1 className="text-6xl font-black  tracking-wide text-center opacity-70">
            PokeLands
          </h1>
        </div>

        <h2 className="text-xl  tracking-tighter text-center opacity-65">
          Your journey awaits.
        </h2>

        <Button variant="default" onClick={nextStep}>
          <span className="text-2xl font-black tracking-wide px-16 py-4">
            START GAME
          </span>
        </Button>
      </div>
    </main>
  );
};
